export function shuffle(input) {
    var a = typeof input == 'string' ? input.split("") : input,
        n = a.length;

    for(var i = n - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var tmp = a[i];
        a[i] = a[j];
        a[j] = tmp;
    }
    return a.join("");
}

export function moveOneLetter(input) {
    let chars = typeof input == 'string' ? input.split("") : input
    let selectedIndex = Math.floor(Math.random() * chars.length)
    const char = chars.splice(selectedIndex, 1)[0]
    const newPosition = Math.floor(Math.random() * chars.length)
    chars.splice(newPosition, 0, char)
    return chars.join("")
}

export function marquee(input) {
    let chars = typeof input == 'string' ? input.split("") : input
    const char = chars.splice(chars.length - 1, 1)
    chars.splice(0, 0, char)

    return chars.join("")
}
